import type { GutXAxisOrgan } from '@repo/types';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import { organAnchorId } from 'views/Results/utils/organs';

/**
 * Picking an organ, from either half of the card. Both report the same `source`,
 * which is what separates this tap from the one on the conditions home page.
 */
export function useOrganSelect() {
  const { currentKitId } = useCurrentKitAndTinyAccount();
  const { trackEvent } = useAnalytics();
  const navigate = useNavigate();

  return useCallback(
    (organ: GutXAxisOrgan) => {
      trackEvent('Conditions Organ Tapped', {
        organ_system: organ.lookup_code,
        source: 'home_card',
      });
      // The sections these anchors point at arrive with ENG-4822.
      navigate(
        `/results/${currentKitId}/conditions#${organAnchorId(organ.lookup_code)}`,
      );
    },
    [currentKitId, navigate, trackEvent],
  );
}

export default useOrganSelect;
